<template>
    <div id="splash-page">
        <div class="logo">
            <img src="../assets/bank-generic-logo.png" alt="">
        </div>
        <div class="title">
            <h2>First Home Saver</h2>
            <p>The fastest way to save for a new house</p>
        </div>
        <div class="directions">
            <p>This app works with your<br>[Bank Name] checking account.</p>
            <p>Please log in with your regular online banking credentials.</p>
        </div>
        <form class="login-form" @submit.prevent="login">
            <div class="field">
                <label for="username">Username</label>
                <input type="text" id="username" v-model="username">
            </div>
            <div class="field">
                <label for="password">Password</label>
                <input type="password" id="password" v-model="password">
            </div>
            <div class="actions">
                <label>
                    <input type="checkbox" v-model="remember">
                    Remember Me
                </label>
                <button type="submit">
                    Log In
                </button>
            </div>
        </form>
    </div>
</template>
<script>
export default {
    name: 'splash-page',
    data() {
        return {
            username: 'test',
            password: '12345678',
            remember: false,
        }
    },
    methods: {
        async login() {
            if (this.username.toLowerCase() == 'test') {
                this.$store.dispatch('setUser', {id: 1, username: 'test'})
                this.$store.dispatch('fakeBankDetails')
                this.$router.push('/main/account-select')
            }
        },
    },
}
</script>
<style lang="scss">
#splash-page {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 0 16px;

    text-align: center;

    .logo {
        width: 55vmin;
        max-width: 300px;
        margin-bottom: 45px;
    }
    .title {
        margin-bottom: 40px;
        h2 {
            font-size: 24px;
            text-transform: uppercase;
            margin-bottom: 0;
            font-weight: bold;
        }
        p {
            font-weight: bold;
            font-size: 14px;
        }
    }
    .directions {
        width: 70vmin;
        max-width: 300px;
        p {
            margin-bottom: 32px;
        }
    }
    form {
        margin-top: 8px;
        .actions {
            margin-top: 24px;
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-gap: 12px;
            align-items: center;
            label {
                font-size: 12px;

                input {
                    vertical-align: middle;
                }
            }
            button {
                background: #095E90;
                background-image: linear-gradient(to bottom, #095E90 0%, #055282 100%);
                color: white;
                font-size: 14px;
                padding: 10px 14px;
                border-radius: 8px;
            }
        }
    }
}
</style>
